(() => {
  var l = {
    goal: { match: "Match My Hair", create: "Create My Look" },
    leave: {
      yes: "Yes, I'll leave some hair out.",
      covered: "No, I plan to cover the front.",
      unsure: "I'm not sure yet.",
    },
    finish: {
      natural: "Natural curls or coils",
      blowout: "Blown-out or stretched",
      straight: "Smooth and straight",
      unsure: "I'm not sure",
    },
    texture: {
      kinky: "4B\u20134C Kinky",
      coily: "3C\u20134A Coily",
      curly: "3B\u20133C Curly",
      blowout: "Kinky Blowout",
    },
    format: {
      seamless: "Seamless Clip-Ins",
      classic: "Classic Clip-Ins",
      halfwig: "3-in-1 Half Wigs",
      wefts: "Hair Wefts",
      unsure: "I'm Not Sure Yet",
    },
    cover: {
      headband: "Separate headband",
      other: "Another covering method",
      unsure: "Not sure yet",
    },
    blend: {
      already: "My hair already looks similar.",
      style: "Yes, I'll style my leave-out.",
      no: "No, I want to keep my natural texture.",
      unsure: "Not sure yet.",
    },
  };
  function ot(c) {
    let w = c.goal === "create" && c.leave === "yes",
      h = c.leave === "covered" && c.formatChoice === "halfwig";
    return {
      goal: l.goal[c.goal] || "Not selected",
      leave: l.leave[c.leave] || "Not selected",
      finish: l.finish[c.finish] || "Not selected",
      textures: c.textures.length
        ? c.textures.map((P) => l.texture[P]).join(" / ")
        : "No texture selected",
      blend: w ? l.blend[c.blendChoice] || "Not answered" : "Not applicable",
      format: l.format[c.formatChoice] || "Not selected",
      cover: h ? l.cover[c.coverChoice] || "Not answered" : "Not applicable",
    };
  }
  function ne(c, w = {}) {
    let h = ot(c),
      P = w.channel === "consultation",
      O = [
        P
          ? "URCROWNHAIR \u2014 Personal Texture Consultation"
          : "URCROWNHAIR \u2014 FIND YOUR TEXTURE",
        "Goal: " + h.goal,
        "Natural hair visible: " + h.leave,
        "Desired finish: " + h.finish,
        "Texture selection: " + h.textures,
        "Blending plan: " + h.blend,
        "Preferred format: " + h.format,
        "Front cover: " + h.cover,
      ];
    return (
      w.category && O.push("Result category: " + w.category),
      w.label && O.push("Result label: " + w.label),
      O.push(
        P
          ? "Please review my selections and recommend appropriate next steps."
          : "Note: Selections are not a professional hair-match guarantee.",
      ),
      O.join(`
`)
    );
  }
  async function ve(c, w = document.body) {
    try {
      if (navigator.clipboard?.writeText)
        return (await navigator.clipboard.writeText(c), !0);
    } catch {}
    let h = document.createElement("textarea");
    ((h.value = c),
      (h.readOnly = !0),
      h.setAttribute("aria-hidden", "true"),
      (h.style.cssText = "position:fixed;left:-9999px;top:0;opacity:0"));
    try {
      return (
        w.appendChild(h),
        h.focus({ preventScroll: !0 }),
        h.select(),
        !!document.execCommand("copy")
      );
    } catch {
      return !1;
    } finally {
      h.remove();
    }
  }
  (function () {
    "use strict";
    let c = "__URCROWNHAIR_TEXTURE_QUIZ_FORMS_REFINED_20261030__",
      w = "urcrown:fyt:forms-draft:v2",
      P = "[data-urcrownhair-texture-quiz]",
      O = {
        shape:
          "Compare individual curl size, shape and tightness \u2014 not which photo looks fuller.",
        group:
          "Compare how the curl strands form groups and the overall pattern across the swatch.",
        fall: "Compare how the fully dry hair naturally falls under consistent styling conditions.",
      };
    function se(u) {
      if (u.dataset.quizInitialized === "forms-refined-20261030") return;
      let n = (t) => u.querySelector(t),
        v = (t) => Array.from(u.querySelectorAll(t)),
        ue = v("[data-quiz-panel]"),
        B = n("[data-quiz-progress]"),
        le = v("[data-quiz-texture]"),
        xe = v("[data-quiz-leave]"),
        qe = v("[data-quiz-finish]");
      if (
        ue.length !== 5 ||
        !B ||
        le.length !== 3 ||
        xe.length !== 3 ||
        qe.length !== 4 ||
        v("[data-quiz-goal]").length !== 2
      )
        return;
      ((u.dataset.quizInitialized = "forms-refined-20261030"),
        (u.dataset.quizRuntimeVersion = "forms-refined-20261030"));
      let x = u.dataset.quizSignedIn === "true",
        ce = x ? String(u.dataset.quizCustomerEmail || "").trim() : "",
        ze = x ? String(u.dataset.quizCustomerFirstName || "").trim() : "",
        k = "urcrown:fyt:login-return:v2:" + window.location.pathname,
        Ce =
          u.dataset.quizFormsUrl || "/pages/urcrownhair-texture-quiz-results",
        d = n("[data-quiz-login-gate]"),
        E = n("[data-quiz-locked-preview]"),
        e = {
          step: 1,
          goal: null,
          leave: null,
          finish: null,
          view: "natural",
          textures: [],
          comparePair: [],
          compareView: "shape",
          compareChoice: null,
          showWorn: !1,
          blowChoice: null,
          blendChoice: null,
          blendPreviousView: "natural",
          lastStep3View: "natural",
          noMatch: null,
          statusMessage: "",
          formatChoice: null,
          coverChoice: null,
        },
        de = [
          "goal",
          "leave",
          "finish",
          "view",
          "textures",
          "comparePair",
          "compareView",
          "compareChoice",
          "showWorn",
          "blowChoice",
          "blendChoice",
          "blendPreviousView",
          "lastStep3View",
          "noMatch",
          "statusMessage",
          "formatChoice",
          "coverChoice",
        ],
        Se = {
          goal: ["match", "create"],
          leave: ["yes", "covered", "unsure"],
          finish: ["natural", "blowout", "straight", "unsure"],
          view: ["natural", "compare", "blowout", "blend", "review"],
          compareView: ["shape", "group", "fall"],
          compareChoice: ["first", "second", "both", "neither"],
          blowChoice: ["yes", "no", "unsure"],
          blendChoice: ["already", "style", "no", "unsure"],
          blendPreviousView: [
            "natural",
            "compare",
            "blowout",
            "blend",
            "review",
          ],
          lastStep3View: ["natural", "compare", "blowout", "blend", "review"],
          noMatch: ["none", "neither", "blowout-no", "blowout-unsure"],
          formatChoice: ["seamless", "classic", "halfwig", "wefts", "unsure"],
          coverChoice: ["headband", "other", "unsure"],
        };
      function ke(t) {
        try {
          return window.sessionStorage.getItem(t);
        } catch {
          return null;
        }
      }
      function he(t, o) {
        try {
          return (window.sessionStorage.setItem(t, o), !0);
        } catch {
          return !1;
        }
      }
      function A(t) {
        try {
          window.sessionStorage.removeItem(t);
        } catch {}
      }
      function $() {
        return !!(
          e.goal &&
          e.leave &&
          e.finish &&
          e.formatChoice &&
          (!R() || e.coverChoice)
        );
      }
      function fe() {
        let t = {};
        return (
          de.forEach((o) => {
            t[o] = e[o];
          }),
          he(
            k,
            JSON.stringify({
              v: 2,
              at: Date.now(),
              awaitingLogin: !0,
              answers: t,
            }),
          )
        );
      }
      // Restore only validated, complete choices. No selections are put in a URL.
      const resultReturnKey = "urcrown:fyt:result-return:v1";
      function applyReturnAnswers(answers) {
        if (!answers || typeof answers !== "object") return false;
        for (const [key, values] of Object.entries(Se)) {
          if (
            answers[key] !== null &&
            answers[key] !== undefined &&
            !values.includes(answers[key])
          )
            return false;
        }
        for (const key of ["textures", "comparePair"]) {
          if (
            !Array.isArray(answers[key]) ||
            answers[key].length > 2 ||
            new Set(answers[key]).size !== answers[key].length ||
            !answers[key].every((value) =>
              ["kinky", "coily", "curly", "blowout"].includes(value),
            )
          )
            return false;
        }
        if (
          typeof answers.showWorn !== "boolean" ||
          typeof answers.statusMessage !== "string" ||
          answers.statusMessage.length > 1000 ||
          !answers.goal ||
          !answers.leave ||
          !answers.finish ||
          !answers.formatChoice ||
          (answers.leave === "covered" &&
            answers.formatChoice === "halfwig" &&
            !answers.coverChoice)
        )
          return false;
        de.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(answers, key))
            e[key] = answers[key];
        });
        e.textures = answers.textures.slice();
        e.comparePair = answers.comparePair.slice();
        e.step = 5;
        return true;
      }
      function Ee() {
        if (!x) return false;
        const raw = ke(k);
        A(k);
        if (!raw) return false;
        try {
          const saved = JSON.parse(raw);
          if (
            saved?.v !== 2 ||
            saved.awaitingLogin !== true ||
            !Number.isFinite(saved.at) ||
            Date.now() - saved.at > 1500000 ||
            saved.at > Date.now() + 60000
          )
            return false;
          return applyReturnAnswers(saved.answers);
        } catch {
          return false;
        }
      }
      function keepResultForForm() {
        const answers = {};
        de.forEach((key) => {
          answers[key] = Array.isArray(e[key]) ? e[key].slice() : e[key];
        });
        const path = window.location.pathname;
        if (
          !/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/find-your-texture$/i.test(
            path,
          )
        )
          return false;
        return he(
          resultReturnKey,
          JSON.stringify({ v: 1, at: Date.now(), email: ce, path, answers }),
        );
      }
      function restoreFormResult() {
        if (
          !x ||
          new URLSearchParams(window.location.search).get("fyt_return") !== "1"
        )
          return false;
        try {
          const saved = JSON.parse(ke(resultReturnKey) || "null");
          if (
            saved?.v !== 1 ||
            !Number.isFinite(saved.at) ||
            Date.now() - saved.at > 1500000 ||
            saved.at > Date.now() + 60000 ||
            saved.path !== window.location.pathname ||
            typeof saved.email !== "string" ||
            saved.email.toLowerCase() !== ce.toLowerCase()
          )
            return false;
          return applyReturnAnswers(saved.answers);
        } catch {
          return false;
        }
      }
      function Ae() {
        let t = K();
        return ne(e, { category: t, label: X(t).label });
      }
      function Re() {
        if (!x || !ce || e.step !== 5) {
          r(
            "[data-quiz-save-status]",
            "Please sign in before saving your selections.",
          );
          return;
        }
        let t = n("[data-quiz-save-to-forms]");
        if (t.disabled) return;
        let o = {
          v: 2,
          at: Date.now(),
          email: ce,
          firstName: ze,
          summary: Ae(),
        };
        if (!he(w, JSON.stringify(o))) {
          r(
            "[data-quiz-save-status]",
            "Your browser cannot hold these selections. Please allow temporary site storage and try again.",
          );
          return;
        }
        let a;
        try {
          let i = new URL(Ce, window.location.href);
          if (
            i.origin !== window.location.origin ||
            i.pathname !== "/pages/urcrownhair-texture-quiz-results"
          )
            throw new Error("Unexpected form destination");
          let s = new URLSearchParams(window.location.search).get(
            "preview_theme_id",
          );
          (s &&
            /^\d{5,20}$/.test(s) &&
            i.searchParams.set("preview_theme_id", s),
            (a = i.pathname + i.search + i.hash));
        } catch {
          (A(w),
            r(
              "[data-quiz-save-status]",
              "The save form URL needs to be checked. Your answers remain on this page.",
            ));
          return;
        }
        if (!keepResultForForm()) {
          r(
            "[data-quiz-save-status]",
            "Your browser cannot keep a return copy of these results. Please allow temporary site storage and try again.",
          );
          return;
        }
        ((t.disabled = !0),
          r("[data-quiz-save-status]", "Opening your details\u2026"));
        try {
          window.location.assign(a);
        } catch {
          ((t.disabled = !1),
            r(
              "[data-quiz-save-status]",
              "The form could not be opened. Please try again.",
            ));
        }
      }
      function D() {
        (d && d.open && d.close(),
          (u.dataset.quizResultsLocked = "false"),
          E && (E.hidden = !0),
          A(k),
          !x && e.step === 5 && m(4));
      }
      function Te() {
        if (!d) return;
        (fe()
          ? r(
              "[data-quiz-login-status]",
              "Your answers are temporarily held in this tab for the sign-in return.",
            )
          : r(
              "[data-quiz-login-status]",
              "Temporary storage is blocked. After signing in, you may need to repeat the quiz.",
            ),
          (u.dataset.quizResultsLocked = "true"),
          E && (E.hidden = !1),
          m(5));
        let t = n('[data-quiz-panel="5"]');
        if (
          (t &&
            typeof t.scrollIntoView == "function" &&
            t.scrollIntoView({ behavior: "auto", block: "start" }),
          !d.open)
        )
          try {
            typeof d.showModal == "function"
              ? d.showModal()
              : d.setAttribute("open", "");
          } catch {
            (d.setAttribute("open", ""),
              r(
                "[data-quiz-login-status]",
                "The sign-in popup could not open normally. You can still use the sign-in link above.",
              ));
          }
      }
      d &&
        d.addEventListener("cancel", (t) => {
          (t.preventDefault(), D());
        });
      let pe = n("[data-quiz-login-link]");
      pe &&
        pe.addEventListener("click", (t) => {
          if (e.step !== 5 || !$() || x) {
            (t.preventDefault(),
              r(
                "[data-quiz-login-status]",
                "Finish Step 04 before signing in to see your result.",
              ));
            return;
          }
          fe() ||
            r(
              "[data-quiz-login-status]",
              "Temporary storage is unavailable. You may need to retake the quiz after signing in.",
            );
        });
      function V() {
        ((e.formatChoice = null), (e.coverChoice = null));
      }
      function M() {
        (V(),
          (e.textures = []),
          (e.comparePair = []),
          (e.compareChoice = null),
          (e.compareView = "shape"),
          (e.showWorn = !1),
          (e.blowChoice = null),
          (e.blendChoice = null),
          (e.noMatch = null),
          (e.statusMessage = ""));
      }
      function C(t, o, a) {
        v(t).forEach((i) => {
          let s = i.getAttribute(a) === o;
          (i.classList.toggle("is-selected", s),
            i.setAttribute("aria-pressed", String(s)));
        });
      }
      function r(t, o) {
        v(t).forEach((a) => {
          a.textContent = o;
        });
      }
      function R() {
        return e.leave === "covered" && e.formatChoice === "halfwig";
      }
      function Ne() {
        let t = [];
        return (
          (e.noMatch || e.textures.length === 0) &&
            t.push(
              "You haven't chosen a texture yet. A hair format alone won't tell us which curl pattern suits you.",
            ),
          e.leave === "covered" &&
            ["seamless", "classic", "wefts"].includes(e.formatChoice) &&
            t.push(
              "This format alone does not ensure a fully concealed front. Additional installation choices or components may be needed.",
            ),
          R() &&
            (e.coverChoice === "headband" &&
              t.push(
                "A separate headband may be needed. Check what's included on the product page.",
              ),
            e.coverChoice === "other" &&
              t.push(
                "Your chosen front-covering method still needs compatibility confirmation.",
              ),
            e.coverChoice === "unsure" &&
              t.push(
                "Choose a front-covering method before deciding whether this half wig suits your needs.",
              )),
          e.leave === "unsure" &&
            t.push(
              "Decide whether you want to leave your natural hair out; it affects how you wear the product.",
            ),
          e.goal === "create" &&
            e.leave === "yes" &&
            ["no", "unsure"].includes(e.blendChoice) &&
            t.push(
              "The selected look may not blend with visible natural hair without further styling or guidance.",
            ),
          e.formatChoice === "unsure" &&
            t.push(
              "Our team can help you choose between clip-ins, half wigs, and wefts.",
            ),
          e.finish === "straight" &&
            t.push(
              "For a smooth, silky-straight finish, explore options beyond our current natural textures.",
            ),
          t
        );
      }
      function Pe() {
        (C("[data-quiz-format]", e.formatChoice, "data-quiz-format"),
          C("[data-quiz-cover]", e.coverChoice, "data-quiz-cover"),
          r(
            "[data-quiz-format-context-note]",
            e.noMatch || e.textures.length === 0
              ? "You can still explore how each format works, even without a texture direction."
              : "Now choose the kind of hair product you'd like to wear.",
          ),
          r(
            "[data-quiz-step4-texture]",
            e.noMatch || e.textures.length === 0
              ? "No texture selected \u2014 explore product types"
              : e.textures.map((i) => l.texture[i]).join(" / "),
          ),
          r(
            "[data-quiz-textures-summary]",
            e.noMatch || e.textures.length === 0
              ? "No texture selected"
              : e.textures.map((i) => l.texture[i]).join(" / "),
          ),
          r(
            "[data-quiz-blend-summary]",
            e.blendChoice ? l.blend[e.blendChoice] : "Not applicable",
          ));
        let t = n("[data-quiz-result-blend-row]");
        t && (t.hidden = !S());
        let o = n("[data-quiz-cover-field]");
        ((o.hidden = !R()),
          (n("[data-quiz-format-next]").disabled =
            !e.formatChoice || (R() && !e.coverChoice)));
        let a = e.formatChoice ? Ne() : [];
        ((n("[data-quiz-format-notice]").hidden = a.length === 0),
          r("[data-quiz-format-notice-text]", a.join(" ")),
          r(
            "[data-quiz-format-summary]",
            l.format[e.formatChoice] || "Not selected",
          ),
          r(
            "[data-quiz-cover-summary]",
            l.cover[e.coverChoice] || "Not answered",
          ),
          r(
            "[data-quiz-format-status]",
            a.length ? "Details to confirm" : "Your selected format",
          ),
          r(
            "[data-quiz-final-caution]",
            a.length
              ? a.join(" ")
              : "Check how the product will be installed and whether your natural hair will be left out.",
          ));
      }
      function S() {
        return e.goal === "create" && e.leave === "yes";
      }
      function m(t, o) {
        ((e.step = t), o && (e.view = o), g());
        let a = n(`[data-quiz-panel="${t}"] [data-quiz-heading]`);
        a && a.focus({ preventScroll: !0 });
        let i =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        u.scrollIntoView &&
          u.scrollIntoView({ behavior: i ? "auto" : "smooth", block: "start" });
      }
      function L(t) {
        m(3, t);
      }
      function I() {
        ((e.lastStep3View = e.view), m(4));
      }
      function Le() {
        e.textures.length === 2
          ? ((e.comparePair = [...e.textures]),
            (e.compareChoice = null),
            (e.compareView = "shape"),
            (e.showWorn = !1),
            L("compare"))
          : e.textures.length === 1 &&
            (S() ? ((e.blendPreviousView = "natural"), L("blend")) : I());
      }
      function Ie() {
        if (!(!e.compareChoice || e.comparePair.length !== 2)) {
          if (e.compareChoice === "neither") {
            ((e.noMatch = "neither"), (e.textures = []), I());
            return;
          }
          ((e.noMatch = null),
            e.compareChoice === "first" && (e.textures = [e.comparePair[0]]),
            e.compareChoice === "second" && (e.textures = [e.comparePair[1]]),
            e.compareChoice === "both" && (e.textures = [...e.comparePair]),
            S()
              ? ((e.blendPreviousView = "compare"),
                (e.blendChoice = null),
                L("blend"))
              : I());
        }
      }
      function Oe() {
        if (e.blowChoice) {
          if (e.blowChoice !== "yes") {
            ((e.noMatch =
              e.blowChoice === "no" ? "blowout-no" : "blowout-unsure"),
              (e.textures = []),
              I());
            return;
          }
          ((e.noMatch = null),
            (e.textures = ["blowout"]),
            S() ? ((e.blendPreviousView = "blowout"), L("blend")) : I());
        }
      }
      function Me() {
        e.comparePair.length === 2 &&
          ((e.textures = [...e.comparePair]), (e.noMatch = null));
      }
      function _e() {
        if (e.step === 5) {
          m(4);
          return;
        }
        if (e.step === 4) {
          m(3, e.lastStep3View);
          return;
        }
        if (e.step === 3) {
          if (e.view === "compare") {
            L("natural");
            return;
          }
          if (e.view === "blend") {
            (e.blendPreviousView === "compare" && Me(), L(e.blendPreviousView));
            return;
          }
          m(2);
          return;
        }
        e.step === 2 && m(1);
      }
      function H(t, o) {
        if (!t || t.dataset.quizImageKey === o) return;
        t.dataset.quizImageKey = o;
        let a =
          u.querySelector(`template[data-quiz-image-template="${o}"]`) ||
          u.querySelector(`template[data-quiz-model-template="${o}"]`);
        a
          ? t.replaceChildren(a.content.cloneNode(!0))
          : t.replaceChildren(document.createTextNode("Image unavailable"));
      }
      function Ye() {
        let t = e.comparePair.length === 2 ? e.comparePair : e.textures;
        if (t.length !== 2) return;
        (["first", "second"].forEach((a, i) => {
          let s = t[i];
          (r(`[data-quiz-compare-label="${a}"]`, l.texture[s]),
            r(
              `[data-quiz-compare-choice-label="${a}"]`,
              l.texture[s] +
                (e.goal === "match" ? " looks closer." : " is my preference."),
            ),
            H(n(`[data-quiz-compare-image="${a}"]`), s + "-" + e.compareView),
            H(n(`[data-quiz-model-image="${a}"]`), s));
        }),
          r("[data-quiz-compare-tip]", O[e.compareView]),
          v("[data-quiz-compare-view]").forEach((a) => {
            a.setAttribute(
              "aria-pressed",
              String(a.dataset.quizCompareView === e.compareView),
            );
          }),
          C(
            "[data-quiz-compare-choice]",
            e.compareChoice,
            "data-quiz-compare-choice",
          ),
          (n("[data-quiz-compare-next]").disabled = !e.compareChoice),
          n("[data-quiz-worn-toggle]").setAttribute(
            "aria-expanded",
            String(e.showWorn),
          ),
          (n("[data-quiz-worn-panel]").hidden = !e.showWorn));
        let o = n("[data-quiz-worn-label]");
        o &&
          (o.textContent = e.showWorn
            ? "Hide worn looks"
            : "See these textures worn");
      }
      function Ue() {
        let t = [];
        return (
          e.leave === "unsure" &&
            t.push(
              "Decide whether you want to leave any natural hair out; this will help you choose an installation method.",
            ),
          e.leave === "covered" &&
            ["seamless", "classic", "wefts"].includes(e.formatChoice) &&
            t.push(
              "This product format alone does not ensure a covered front. Check the full installation method.",
            ),
          R() &&
            e.coverChoice === "unsure" &&
            t.push(
              "You have not settled on a method for covering the front of the half wig.",
            ),
          R() &&
            e.coverChoice === "other" &&
            t.push(
              "Your alternative method of covering the front needs compatibility confirmation.",
            ),
          R() &&
            e.coverChoice === "headband" &&
            t.push(
              "A separate headband may be needed. Check what's included on the product page.",
            ),
          S() &&
            e.blendChoice === "no" &&
            t.push(
              "You plan to leave natural hair visible without styling it to blend. The selected texture may be visually different.",
            ),
          S() &&
            e.blendChoice === "unsure" &&
            t.push(
              "How your leave-out will blend with this texture has not been established.",
            ),
          e.finish === "straight" &&
            t.push("Kinky Blowout is not the same as a silky-straight finish."),
          t
        );
      }
      function K() {
        if (e.noMatch || !e.textures.length) return "R4";
        let t = S() && ["no", "unsure"].includes(e.blendChoice),
          o =
            e.leave === "covered" &&
            (["seamless", "classic", "wefts"].includes(e.formatChoice) ||
              (e.formatChoice === "halfwig" &&
                ["unsure", "other"].includes(e.coverChoice)));
        return e.leave === "unsure" ||
          t ||
          o ||
          e.formatChoice === "unsure" ||
          e.finish === "straight"
          ? "R3"
          : e.textures.length === 2
            ? "R2"
            : "R1";
      }
      function X(t) {
        let o = e.goal === "match",
          a = e.textures.map((T) => l.texture[T]),
          i = a.join(" + "),
          s = a.length > 1,
          f = e.formatChoice === "unsure",
          b = S() && ["no", "unsure"].includes(e.blendChoice),
          q =
            e.leave === "covered" &&
            (["seamless", "classic", "wefts"].includes(e.formatChoice) ||
              (e.formatChoice === "halfwig" &&
                ["unsure", "other"].includes(e.coverChoice)));
        return {
          R1: {
            label: "YOUR TEXTURE PICK",
            title: "Your look starts here.",
            intro: o
              ? "You selected " + i + " to compare with your natural hair."
              : "You selected " + i + " for the look you want.",
            heading: i,
            description: o
              ? "See the curl pattern up close, then compare it with your own hair."
              : "See the texture up close and explore your ways to wear it.",
          },
          R2: {
            label: "TWO TEXTURES SELECTED",
            title: "Two textures made your shortlist.",
            intro: "You selected two textures to compare.",
            heading: i,
            description: o
              ? "If you plan to leave hair out, compare both curl patterns with your natural hair before deciding."
              : "See both textures up close and explore the styles you can create.",
          },
          R3: {
            label: s ? "YOUR TEXTURE SHORTLIST" : "YOUR TEXTURE PICK",
            title: f
              ? s
                ? "Two textures. Let's find how to wear them."
                : "Your texture is chosen. Your next step is how to wear it."
              : q
                ? "Let's plan your front coverage."
                : b
                  ? "Let's make the blend work for you."
                  : "Let's get the details right.",
            intro: f
              ? s
                ? "You have two textures in mind. Explore the product types before deciding."
                : "You've chosen " +
                  i +
                  ". Next, find the product type that fits your routine."
              : s
                ? "Both textures remain possibilities. A few styling details need attention."
                : "You've chosen " +
                  i +
                  ". A few styling details need attention.",
            heading: i,
            description: f
              ? "Your texture choice is a starting point. Choose how you'd like to wear it, or ask our team for guidance."
              : q
                ? "Check how the front will be covered before deciding on your installation."
                : b
                  ? "Your leave-out may need styling to blend with your chosen texture."
                  : "Review the remaining fit and installation details before choosing a product.",
          },
          R4: {
            label: "KEEP EXPLORING",
            title: "Let's find what works for you.",
            intro:
              "No texture has been selected with enough information to recommend one yet.",
            heading: "No texture selected yet",
            description:
              e.finish === "straight"
                ? "The textures shown here do not include a silky-straight option. Kinky Blowout has a blown-out finish, not a silk-press finish. Ask our team about your options."
                : "None of the available textures has been selected as a suitable direction. You can review the photos again or ask our team for help.",
          },
        }[t];
      }
      function Ve(t, o) {
        let a = document.createElement("article");
        a.className = "urcrownhair-quiz__result-texture";
        let i = document.createElement("div");
        ((i.className = "urcrownhair-quiz__result-texture-image"),
          H(i, o === "blowout" ? "blowout-shape" : o + "-fall"),
          a.append(i),
          t.append(a));
      }
      function We(t) {
        let o = n("[data-quiz-result-details]");
        if (!o) return;
        o.replaceChildren();
        let a = [
          ["shape", "CURL SHAPE"],
          ["group", "CURL GROUPING"],
          ["fall", "NATURAL FALL"],
        ];
        (t.forEach((i) => {
          (i === "blowout"
            ? [
                ["blowout-shape", "BLOWN-OUT TEXTURE"],
                ["blowout-model", "WORN LOOK"],
              ]
            : a.map(([f, b]) => [i + "-" + f, b])
          ).forEach(([f, b]) => {
            let q = n(
              f === "blowout-model"
                ? '[data-quiz-model-template="blowout"]'
                : `[data-quiz-image-template="${f}"]`,
            );
            if (!q || !q.content.querySelector("img")) return;
            let y = document.createElement("div");
            y.className = "urcrownhair-quiz__result-detail";
            let T = document.createElement("div");
            ((T.className = "urcrownhair-quiz__result-detail-image"),
              T.append(q.content.cloneNode(!0)));
            let Y = document.createElement("p");
            ((Y.className = "urcrownhair-quiz__eyebrow"),
              (Y.textContent =
                t.length === 2 ? l.texture[i] + " \xB7 " + b : b),
              y.append(T, Y),
              o.append(y));
          });
        }),
          (o.hidden = o.childElementCount === 0));
      }
      function at(t, o) {
        let a = document.createElement("div");
        a.className =
          "urcrownhair-quiz__result-unmapped urcrownhair-quiz__result-availability";
        let i = document.createElement("strong");
        i.textContent = l.texture[t] + " \xB7 " + l.format[o];
        let s = document.createElement("span");
        return (
          (s.textContent =
            "We can\u2019t show a product for this combination right now. Explore another option or ask our team for guidance."),
          a.append(i, s),
          a
        );
      }
      function Fe() {
        let t = K(),
          o = X(t);
        (r("[data-quiz-result-title]", o.title),
          r("[data-quiz-result-tag]", o.label),
          r("[data-quiz-result-heading]", o.heading),
          r("[data-quiz-result-description]", o.description),
          r("[data-quiz-result-intro]", o.intro),
          r(
            "[data-quiz-format-status]",
            t === "R4"
              ? "Still exploring"
              : t === "R3"
                ? "Details to confirm"
                : "Your selected format",
          ));
        let a = n("[data-quiz-result-textures-section]"),
          i = n("[data-quiz-result-textures]");
        i.replaceChildren();
        let s = t !== "R4" && e.textures.length > 0;
        ((a.hidden = !s),
          s && e.textures.forEach((z) => Ve(i, z)),
          We(s ? e.textures : []));
        let f = n("[data-quiz-product-section]"),
          b = n("[data-quiz-result-products]");
        b.replaceChildren();
        let q = !!e.formatChoice && e.formatChoice !== "unsure",
          y = s && !q,
          T = 0,
          Y = 0;
        function ye(z, U, W) {
          let N = n(`[data-quiz-product-template="${z}-${U}"]`);
          if (!N) return !1;
          let j = N.content.cloneNode(!0),
            ie = j.querySelector(".urcrownhair-quiz__product-card");
          if (ie && W) {
            ie.classList.add("urcrownhair-quiz__product-card--alternative");
            let tt = ie.querySelector(".urcrownhair-quiz__product-information"),
              re = document.createElement("span");
            ((re.className = "urcrownhair-quiz__product-alternative-label"),
              (re.textContent = W),
              tt.prepend(re));
          }
          return (b.append(j), !0);
        }
        let Qe = ["seamless", "classic", "halfwig", "wefts"];
        (s &&
          e.textures.forEach((z) => {
            if (q && ye(z, e.formatChoice, null)) T++;
            else {
              let U = Qe.filter((N) => N !== e.formatChoice),
                W = 0;
              for (let N of U) {
                if (W >= (y ? 3 : 2)) break;
                let j = y
                  ? "A WAY TO WEAR IT \xB7 " + l.format[N]
                  : "DIFFERENT FORMAT \xB7 " + l.format[N];
                ye(z, N, j) && (W++, Y++);
              }
            }
          }),
          (f.hidden = !s || b.childElementCount === 0),
          (n("[data-quiz-product-footnote]").hidden = f.hidden),
          r(
            "[data-quiz-product-heading]",
            q ? "Recommended for your texture" : "Ways to wear your texture",
          ),
          r(
            "[data-quiz-product-intro]",
            y
              ? "You haven't chosen a product type yet. These are available ways to wear your selected texture, not confirmed installation recommendations."
              : Y && !T
                ? "Your selected product format is not linked right now. These are other formats in the same texture; check how they are installed before choosing."
                : t === "R3"
                  ? "Explore the product you selected. Review the unresolved styling or installation details before purchasing."
                  : "Your selected texture and product format, with details from the actual product page.",
          ));
        let Ze = n("[data-quiz-result-next-step]"),
          ee = n("[data-quiz-next-step-title]"),
          te = n("[data-quiz-next-step-description]"),
          oe = n("[data-quiz-next-step-review]");
        ((Ze.hidden = !(y || t === "R4" || (s && f.hidden))),
          y
            ? ((ee.textContent = "Not sure how to wear your texture?"),
              (te.textContent =
                "Compare the different product types or ask our team which installation approach may work for you."),
              (oe.textContent = "\u2190 Compare product types"))
            : t === "R4"
              ? ((ee.textContent =
                  e.finish === "straight"
                    ? "Looking for a different finish?"
                    : "Still looking for your texture?"),
                (te.textContent =
                  e.finish === "straight"
                    ? "The textures shown here do not include a silky-straight option. Kinky Blowout is a stretched finish, not a silk press."
                    : "No reliable texture was identified from these answers. Review the textures or ask our team for help."),
                (oe.textContent = "\u2190 Review texture options"))
              : s &&
                f.hidden &&
                ((ee.textContent = "Let us help you find an option."),
                (te.textContent =
                  "We do not have a product linked to this combination right now. Review other formats or ask our team about available options."),
                (oe.textContent = "\u2190 Compare product types")));
        let ae =
          t === "R4"
            ? []
            : Ue().filter(
                (z) => !(y && /not chosen an extension format/i.test(z)),
              );
        t !== "R4" &&
          e.goal === "match" &&
          e.leave === "yes" &&
          ae.push(
            e.textures.includes("blowout")
              ? "For leave-out, compare the stretched finish with how you style your own hair."
              : "For leave-out, compare the curl pattern with your natural hair before buying.",
          );
        let et = n("[data-quiz-result-warnings-section]"),
          be = n("[data-quiz-result-warnings]");
        (be.replaceChildren(),
          ae.forEach((z) => {
            let U = document.createElement("li");
            ((U.textContent = z), be.append(U));
          }),
          (et.hidden = ae.length === 0),
          r(
            "[data-quiz-result-guidance]",
            t === "R4"
              ? "Our team can help you compare the textures and find a style you feel good about."
              : y
                ? "We can help you choose how to wear this texture with your hair and routine."
                : t === "R3"
                  ? "Let us review your leave-out, blending or installation details together."
                  : "Our texture team is here if you would like a second opinion.",
          ));
      }
      function Be() {
        A(resultReturnKey);
        (A(k),
          A(w),
          d && d.open && d.close(),
          (u.dataset.quizResultsLocked = "false"),
          E && (E.hidden = !0),
          (e.step = 1),
          (e.goal = null),
          (e.leave = null),
          (e.finish = null),
          (e.view = "natural"),
          (e.blendPreviousView = "natural"),
          (e.lastStep3View = "natural"),
          M(),
          (e.formatChoice = null),
          (e.coverChoice = null),
          r("[data-quiz-copy-status]", ""));
        let t = n("[data-quiz-consult-notes]");
        t && (t.value = "");
        let o = n("[data-quiz-consult-name]");
        o && (o.value = "");
        let a = n("[data-quiz-consult-status]");
        (a && (a.textContent = ""), p && p.open && p.close(), m(1));
      }
      function De() {
        let t, o;
        (e.goal === "create"
          ? ((t = "What finish do you want for your look?"),
            (o = "Think about the finished hairstyle you want to wear."))
          : e.leave === "yes"
            ? ((t = "How will you style your leave-out?"),
              (o =
                "Choose the finish you plan to give the hair you leave out."))
            : e.leave === "covered"
              ? ((t = "What finish do you want to wear?"),
                (o = "Choose the finish you want to wear."))
              : ((t = "What finish are you going for?"),
                (o = "Choose the finish you want to wear.")),
          r(
            "[data-quiz-step2-heading]",
            e.goal === "create"
              ? "Let's plan your look."
              : e.leave === "yes"
                ? "Let's plan your blend."
                : "Let's find your texture.",
          ),
          r("[data-quiz-finish-question]", t),
          r("[data-quiz-finish-hint]", o),
          r(
            "[data-quiz-step2-intro]",
            e.goal === "create"
              ? "Tell us how you want your hair to look and whether you'll leave any out."
              : "Your leave-out and hair finish will help us narrow down your texture options.",
          ));
        let a = "";
        e.finish === "straight"
          ? (a =
              "Kinky Blowout is a textured finish, not the same as silky straight hair. We'll explain the difference next.")
          : S()
            ? (a =
                "Because your natural hair will remain visible, we'll check whether it can blend with your chosen look.")
            : e.leave === "covered"
              ? (a =
                  "We'll explore front coverage options when you choose how to wear your hair.")
              : e.leave === "unsure" &&
                (a =
                  "You can keep exploring. We'll help you consider front coverage when you choose a format.");
        let i = n("[data-quiz-step2-note]");
        ((i.hidden = !a), r("[data-quiz-step2-note-text]", a));
      }
      function He() {
        let t = {
          natural: {
            eyebrow: "STEP 03 \u2014 FIND YOUR TEXTURE",
            title:
              e.goal === "match"
                ? "Which curl pattern looks most like yours?"
                : "Which texture would you love to wear?",
            description:
              e.goal === "match"
                ? "Compare the curl patterns and select up to two that resemble your natural hair."
                : "Look closely at the textures and choose up to two for your desired style.",
          },
          compare: {
            eyebrow: "STEP 03 \u2014 COMPARE TEXTURES",
            title: "Compare your textures.",
            description:
              "Look at curl shape, grouping, and how the hair falls side by side.",
          },
          blowout: {
            eyebrow: "STEP 03 \u2014 FIND YOUR TEXTURE",
            title: "See the Kinky Blowout texture",
            description:
              "Compare the stretched texture with the blown-out finish you want.",
          },
          review: {
            eyebrow: "STEP 03 \u2014 EXPLORE YOUR OPTIONS",
            title:
              e.finish === "straight"
                ? "Looking for a straight finish?"
                : "Not sure where to begin?",
            description:
              e.finish === "straight"
                ? "A silky-straight look is different from Kinky Blowout. Review the textures we carry or ask our team for help."
                : "Look through our curl patterns, or ask our team to help you choose.",
          },
          blend: {
            eyebrow: "STEP 03 \u2014 CONFIRM YOUR BLEND",
            title: "How will you blend your leave-out?",
            description:
              "If your natural hair will show, consider whether its texture matches or needs styling.",
          },
        }[e.view];
        (r("[data-quiz-step3-eyebrow]", t.eyebrow),
          r("[data-quiz-step3-heading]", t.title),
          r("[data-quiz-step3-description]", t.description));
        let o = e.goal === "match";
        (r(
          "[data-quiz-no-match-label]",
          o ? "None looks close?" : "None feels right",
        ),
          r(
            "[data-quiz-compare-prompt]",
            o ? "Which texture looks closer?" : "Which texture do you prefer?",
          ),
          r(
            "[data-quiz-compare-both]",
            o ? "Both look close." : "I like both textures.",
          ),
          r(
            "[data-quiz-compare-neither]",
            o ? "Neither looks close." : "Neither is the look I want.",
          ),
          v("[data-quiz-view]").forEach((a) => {
            a.hidden = a.dataset.quizView !== e.view;
          }));
      }
      function g() {
        (C("[data-quiz-goal]", e.goal, "data-quiz-goal"),
          C("[data-quiz-leave]", e.leave, "data-quiz-leave"),
          C("[data-quiz-finish]", e.finish, "data-quiz-finish"),
          C("[data-quiz-texture]", null, "data-quiz-texture"),
          le.forEach((t) => {
            let o = e.textures.includes(t.dataset.quizTexture);
            (t.classList.toggle("is-selected", o),
              t.setAttribute("aria-pressed", String(o)));
          }),
          C("[data-quiz-blow-choice]", e.blowChoice, "data-quiz-blow-choice"),
          C(
            "[data-quiz-blend-choice]",
            e.blendChoice,
            "data-quiz-blend-choice",
          ),
          ue.forEach((t) => {
            t.hidden = Number(t.dataset.quizPanel) !== e.step;
          }),
          B.setAttribute("aria-valuenow", String(e.step)),
          B.setAttribute("aria-valuetext", `Step ${e.step} of 5`),
          Array.from(B.querySelectorAll("span")).forEach((t, o) => {
            t.classList.toggle("is-active", o < e.step);
          }),
          v("[data-quiz-next]").forEach((t) => {
            let o = t.closest("[data-quiz-panel]");
            t.disabled =
              o.dataset.quizPanel === "1" ? !e.goal : !(e.leave && e.finish);
          }),
          (n("[data-quiz-texture-next]").disabled = e.textures.length === 0),
          (n("[data-quiz-blow-next]").disabled = !e.blowChoice),
          (n("[data-quiz-blend-next]").disabled = !e.blendChoice),
          r(
            "[data-quiz-texture-status]",
            e.statusMessage ||
              (e.textures.length === 2
                ? "Two textures selected. Compare them next."
                : e.textures.length === 1
                  ? "One texture selected."
                  : "Select up to two textures."),
          ),
          r(
            "[data-quiz-selected-summary]",
            e.textures.map((t) => l.texture[t]).join(" / "),
          ),
          r("[data-quiz-goal-summary]", l.goal[e.goal] || "Not selected"),
          r("[data-quiz-leave-summary]", l.leave[e.leave] || "Not selected"),
          r("[data-quiz-finish-summary]", l.finish[e.finish] || "Not selected"),
          De(),
          He(),
          e.step === 3 && e.view === "compare" && Ye(),
          Pe(),
          x && e.step === 5 && Fe(),
          E && (E.hidden = !(e.step === 5 && !x)),
          x && (u.dataset.quizResultsLocked = "false"),
          typeof G == "function" && p && p.open && G());
      }
      let p = n("[data-quiz-consult-panel]");
      function me() {
        return ne(e, {
          channel: "consultation",
          label: e.step === 5 ? X(K()).label : void 0,
        });
      }
      function Ke() {
        return e.goal === "create" && e.leave === "covered"
          ? [
              "A photo of the look you would like to create",
              "Your intended front-covering or installation method (if available)",
              "A natural-hair photo is optional; wet-hair photos are not required",
            ]
          : e.leave === "yes"
            ? [
                "A clear photo of your fully dry natural hair",
                "An optional damp or wet-hair photo for comparison",
                "A close-up of the specific natural hair you plan to leave out",
                ...(e.goal === "create"
                  ? ["A reference photo of the look you want"]
                  : []),
              ]
            : e.goal === "match"
              ? [
                  "A clear photo of your fully dry natural hair",
                  "An optional damp or wet-hair photo",
                  "A photo of the part of your natural hair that may remain visible, if any",
                ]
              : [
                  "A reference photo of the desired look (optional)",
                  "A photo of your natural hair if blending is a concern",
                  "Any information about the front or installation method you are considering",
                ];
      }
      function G() {
        if (!p) return;
        let t = n("[data-quiz-consult-summary]");
        t && (t.textContent = me());
        let o = n("[data-quiz-consult-photo-tips]");
        o &&
          (o.replaceChildren(),
          Ke().forEach((a) => {
            let i = document.createElement("li");
            ((i.textContent = a), o.append(i));
          }));
      }
      function we() {
        if (!p) return;
        (G(),
          J()
            ? _("")
            : _(
                "Email consultation is currently unavailable until our support address is configured. You can still copy your selections.",
              ),
          !p.open && typeof p.showModal == "function" && p.showModal());
        let t = p.querySelector("h2");
        p.open &&
          t &&
          (t.setAttribute("tabindex", "-1"), t.focus({ preventScroll: !0 }));
      }
      function je() {
        p && p.open && p.close();
      }
      function J() {
        let t = String(u.dataset.quizConsultEmail || "").trim();
        return /^[^\s@,;?&\r\n]+@[^\s@,;?&\r\n]+\.[^\s@,;?&\r\n]+$/.test(t)
          ? t
          : "";
      }
      function ge() {
        let t = (n("[data-quiz-consult-name]")?.value || "").trim(),
          o = (n("[data-quiz-consult-notes]")?.value || "").trim();
        return [
          me(),
          "",
          "Name: " + (t || "Not provided"),
          "Customer note:",
          o || "(none)",
          "",
          "PHOTOS: I will attach up to five optional hair photos in my email app.",
          "No face photo is required.",
        ].join(`
`);
      }
      function _(t) {
        let o = n("[data-quiz-consult-status]");
        o && (o.textContent = t);
      }
      function $e(t, o, a) {
        return (
          (t
            ? "To: " +
              t +
              `
`
            : "") +
          "Subject: " +
          o +
          `

` +
          a
        );
      }
      function Xe() {
        let t = J();
        if (!t) {
          _(
            "Email consultation is unavailable because our support address is not configured.",
          );
          return;
        }
        let o = "URCROWNHAIR - Personal Texture Consultation",
          a = ge(),
          i =
            "mailto:" +
            encodeURIComponent(t) +
            "?subject=" +
            encodeURIComponent(o) +
            "&body=" +
            encodeURIComponent(a);
        if (i.length > 1900) {
          _(
            "This draft is too long to prefill reliably. Shorten your note, or use Copy email details below and paste it into a new email.",
          );
          return;
        }
        _("Opening your email draft. Please review it before sending.");
        let s = document.createElement("a");
        ((s.href = i),
          (s.target = "_blank"),
          (s.rel = "noopener noreferrer"),
          (s.style.display = "none"),
          document.body.appendChild(s),
          s.click(),
          s.remove());
      }
      async function Ge() {
        let t = J(),
          a = $e(t, "URCROWNHAIR - Personal Texture Consultation", ge()),
          i = await ve(a, p || u);
        _(
          i
            ? "Email details copied. Paste them into your email app, attach any photos and tap Send."
            : "Copy is unavailable in this browser. You can review your answers below and try another browser or email app.",
        );
      }
      let Q = null,
        Z = null;
      async function Je() {
        let t = n("[data-quiz-share-open]");
        if (!t.disabled) {
          t.disabled = !0;
          try {
            if (!Q) {
              let o = u.dataset.quizShareSrc;
              if (!o) throw new Error("Missing share asset");
              (Z ||
                (Z = import(o).catch((i) => {
                  throw ((Z = null), i);
                })),
                (Q = (await Z).createShareController(u, () =>
                  K() === "R4" ? [] : e.textures.slice(0, 2),
                )));
            }
            (r("[data-quiz-save-status]", ""), Q.open());
          } catch {
            r(
              "[data-quiz-save-status]",
              "The share image could not be opened. Please try again.",
            );
          } finally {
            t.disabled = !1;
          }
        }
      }
      (u.addEventListener("click", (t) => {
        if (!t.target || typeof t.target.closest != "function") return;
        let o = t.target.closest("button");
        if (!(!o || !u.contains(o) || o.disabled)) {
          if (o.hasAttribute("data-quiz-consult-open")) {
            we();
            return;
          }
          if (o.hasAttribute("data-quiz-consult-close")) {
            je();
            return;
          }
          if (o.hasAttribute("data-quiz-consult-email")) {
            Xe();
            return;
          }
          if (o.hasAttribute("data-quiz-consult-copy")) {
            Ge();
            return;
          }
          if (o.hasAttribute("data-quiz-share-open")) {
            Je();
            return;
          }
          if (o.hasAttribute("data-quiz-goal")) {
            let a = o.dataset.quizGoal;
            (a !== e.goal &&
              ((e.goal = a), (e.leave = null), (e.finish = null), M()),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-leave")) {
            let a = o.dataset.quizLeave;
            (a !== e.leave &&
              (e.leave !== null && (e.finish = null), (e.leave = a), M()),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-finish")) {
            let a = o.dataset.quizFinish;
            (a !== e.finish && ((e.finish = a), M()), g());
            return;
          }
          if (o.hasAttribute("data-quiz-next")) {
            if (e.step === 1 && e.goal) m(2);
            else if (e.step === 2 && e.leave && e.finish) {
              let a =
                e.finish === "natural"
                  ? "natural"
                  : e.finish === "blowout"
                    ? "blowout"
                    : "review";
              m(3, a);
            }
            return;
          }
          if (o.hasAttribute("data-quiz-back")) {
            _e();
            return;
          }
          if (o.hasAttribute("data-quiz-next-step-review")) {
            e.step === 5 &&
              (e.noMatch || !e.textures.length ? m(3, e.lastStep3View) : m(4));
            return;
          }
          if (o.hasAttribute("data-quiz-texture")) {
            let a = o.dataset.quizTexture;
            (e.textures.includes(a)
              ? ((e.textures = e.textures.filter((i) => i !== a)),
                (e.statusMessage = ""))
              : e.textures.length < 2
                ? ((e.textures = [...e.textures, a]), (e.statusMessage = ""))
                : (e.statusMessage =
                    "Choose up to two textures. Deselect one before choosing another."),
              V(),
              (e.comparePair = []),
              (e.compareChoice = null),
              (e.blendChoice = null),
              (e.noMatch = null),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-no-match")) {
            (M(), (e.noMatch = "none"), I());
            return;
          }
          if (o.hasAttribute("data-quiz-texture-next")) {
            Le();
            return;
          }
          if (o.hasAttribute("data-quiz-compare-view")) {
            ((e.compareView = o.dataset.quizCompareView), g());
            return;
          }
          if (o.hasAttribute("data-quiz-enlarge")) {
            let a = o.dataset.quizEnlarge,
              i = e.comparePair.length === 2 ? e.comparePair : e.textures,
              s = a === "first" ? i[0] : i[1],
              f = n("[data-quiz-zoom-dialog]");
            s &&
              f &&
              typeof f.showModal == "function" &&
              (r(
                "[data-quiz-zoom-title]",
                l.texture[s] +
                  " \xB7 " +
                  {
                    shape: "Curl Shape",
                    group: "Curl Grouping",
                    fall: "Natural Fall",
                  }[e.compareView],
              ),
              H(n("[data-quiz-zoom-image]"), s + "-" + e.compareView),
              f.showModal());
            return;
          }
          if (o.hasAttribute("data-quiz-close-zoom")) {
            let a = n("[data-quiz-zoom-dialog]");
            a && a.open && a.close();
            return;
          }
          if (o.hasAttribute("data-quiz-worn-toggle")) {
            ((e.showWorn = !e.showWorn), g());
            return;
          }
          if (o.hasAttribute("data-quiz-compare-choice")) {
            (e.compareChoice !== o.dataset.quizCompareChoice && V(),
              (e.compareChoice = o.dataset.quizCompareChoice),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-compare-next")) {
            Ie();
            return;
          }
          if (o.hasAttribute("data-quiz-blow-choice")) {
            (e.blowChoice !== o.dataset.quizBlowChoice && V(),
              (e.blowChoice = o.dataset.quizBlowChoice),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-blow-next")) {
            Oe();
            return;
          }
          if (o.hasAttribute("data-quiz-explore")) {
            ((e.finish = o.dataset.quizExplore),
              M(),
              L(e.finish === "natural" ? "natural" : "blowout"));
            return;
          }
          if (o.hasAttribute("data-quiz-guidance")) {
            we();
            return;
          }
          if (o.hasAttribute("data-quiz-blend-choice")) {
            (e.blendChoice !== o.dataset.quizBlendChoice && V(),
              (e.blendChoice = o.dataset.quizBlendChoice),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-blend-next")) {
            e.blendChoice && I();
            return;
          }
          if (o.hasAttribute("data-quiz-format")) {
            (d && d.open && D(), A(k));
            let a = o.dataset.quizFormat;
            (e.formatChoice !== a &&
              ((e.formatChoice = a), (e.coverChoice = null)),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-cover")) {
            (d && d.open && D(),
              A(k),
              R() && (e.coverChoice = o.dataset.quizCover),
              g());
            return;
          }
          if (o.hasAttribute("data-quiz-login-cancel")) {
            (d && d.open && D(), A(k));
            return;
          }
          if (o.hasAttribute("data-quiz-save-to-forms")) {
            Re();
            return;
          }
          if (o.hasAttribute("data-quiz-restart")) {
            Be();
            return;
          }
          if (o.hasAttribute("data-quiz-format-next")) {
            e.step === 4 && $() && (x ? m(5) : Te());
            return;
          }
        }
      }),
        Ee() || restoreFormResult(),
        g());
    }
    function F(u) {
      (u.matches && u.matches(P) && se(u),
        u.querySelectorAll && u.querySelectorAll(P).forEach(se));
    }
    if (window[c]) {
      window[c].initializeAll(document);
      return;
    }
    ((window[c] = { initializeAll: F }),
      document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", () => F(document), {
            once: !0,
          })
        : F(document),
      window.addEventListener("pageshow", () => {
        document.querySelectorAll("[data-quiz-save-to-forms]").forEach((u) => {
          u.disabled = !1;
        });
      }),
      document.addEventListener("shopify:section:load", (u) => F(u.target)));
  })();
})();
